import { render, staticRenderFns } from "./BillPrintHiprint.bak.vue?vue&type=template&id=2d88bc86&scoped=true"
import script from "./BillPrintHiprint.bak.vue?vue&type=script&lang=js"
export * from "./BillPrintHiprint.bak.vue?vue&type=script&lang=js"
import style0 from "./BillPrintHiprint.bak.vue?vue&type=style&index=0&id=2d88bc86&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d88bc86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d88bc86')) {
      api.createRecord('2d88bc86', component.options)
    } else {
      api.reload('2d88bc86', component.options)
    }
    module.hot.accept("./BillPrintHiprint.bak.vue?vue&type=template&id=2d88bc86&scoped=true", function () {
      api.rerender('2d88bc86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/dialog/BillPrintHiprint.bak.vue"
export default component.exports